import React, { useCallback, useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaSpinner, FaHeartbeat } from 'react-icons/fa';
import { passportService } from '../../services/apiService';
import { PassportContent } from './HealthPassport';

/**
 * B-10D — Public read-only Car Health Passport (7-day share link, no login)
 */
const HealthPassportPublic = () => {
  const { shareToken } = useParams();
  const [passport, setPassport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!shareToken) return;
    setLoading(true);
    try {
      setError('');
      const data = await passportService.getPublicPassport(shareToken);
      setPassport(data);
    } catch (err) {
      setError(err.message || 'This share link is invalid or expired');
      setPassport(null);
    } finally {
      setLoading(false);
    }
  }, [shareToken]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="w-full px-4 pt-3 pb-4 sm:px-6 sm:pt-4 lg:px-8">
      <div className="mx-auto w-full max-w-6xl">
        <div className="mb-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs sm:text-sm text-amber-900">
          <span className="font-semibold">Read-only resale view</span>
          <span className="text-amber-800"> · No login</span>
          {passport?.shareExpiresAt && (
            <span className="text-amber-800">
              {' '}
              · Expires {new Date(passport.shareExpiresAt).toLocaleDateString('en-IN')}
            </span>
          )}
        </div>
        <div className="mb-4 flex items-center gap-2">
          <FaHeartbeat className="text-red-500" />
          <h1 className="text-lg sm:text-xl font-bold text-gray-900">Car Health Passport</h1>
        </div>

        {loading ? (
          <div className="flex justify-center py-12 text-gray-400">
            <FaSpinner className="animate-spin text-2xl" />
          </div>
        ) : error ? (
          <div className="mt-8 rounded-xl border border-red-200 bg-red-50 p-6 text-center">
            <p className="text-sm text-red-700">{error}</p>
            <Link to="/" className="mt-4 inline-block text-sm font-semibold text-blue-600">
              Go to SparePe home
            </Link>
          </div>
        ) : (
          <PassportContent passport={passport} readOnly />
        )}
      </div>
    </div>
  );
};

export default HealthPassportPublic;
